import styled from 'styled-components';
import media from 'components/media/media';

export const QuickLoginWrapper = styled.div`
  display: flex;
  width: 100%;

  justify-content: center;
  padding-left: 16px;
  padding-right: 16px;
  flex-wrap: wrap;
`;

export const QuickLogin = styled.div`
  background-image: url('${({ avatar }) => avatar}');
  background-repeat: no-repeat;
  background-size: contain;

  cursor: pointer;
  transition: all 0.1s;
  border-radius: 10px;
  -webkit-tap-highlight-color: transparent;

  width: 5.908vw;
  height: 150px;
  margin: 6px;

  display: flex;
  align-items: flex-end;
  justify-content: center;
  text-align: center;

  font-family: Roboto;
  color: #c8c8c8;
  font-size: 16px;

  ${media.landscape`
    width: 6.5vw;
    height: 120px;
  `}

  ${media.mobile`
    width: 60px;
    height: 110px;
  `}

  &:hover {
    background-color: rgba(0,0,0,0.03);
    transform: scale(1.03);
  }
`;



// WEBPACK FOOTER //
// ./src/views/LoginView/QuickLogin.js